import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Endpoint Stream integration layer (`src/endpoint/stream`)
 *
 * This directory integrates postMessage `stream_*` messages with the stream object system in `src/stream`:
 * - Demultiplex `stream_*` frames by streamId to the bound handler
 * - Does NOT implement the stream protocol itself (protocol lives in `src/stream`)
 *
 * RequestIframeStreamDispatcher
 *
 * - Maintains streamId -> handler mapping
 * - Dispatches incoming `stream_*` PostMessageData to the mapped handler
 */
export class RequestIframeStreamDispatcher {
  constructor(params) {
    _defineProperty(this, "handlers", new Map());
    this.handledBy = params.handledBy;
  }
  register(streamId, handler) {
    this.handlers.set(streamId, handler);
  }
  unregister(streamId) {
    this.handlers.delete(streamId);
  }
  clear() {
    this.handlers.clear();
  }

  /**
   * Dispatch a framework stream_* PostMessageData to its streamId handler.
   *
   * - If context is provided, dispatcher will mark accepted/handledBy when handler exists.
   * - If context is omitted, dispatcher will skip marking (useful when origin was validated upstream).
   */
  dispatch(data, context) {
    var body = data.body;
    if (!(body !== null && body !== void 0 && body.streamId)) return;
    var handler = this.handlers.get(body.streamId);
    if (!handler) return;
    if (context) {
      context.markAcceptedBy(this.handledBy);
    }
    var messageType = data.type.replace('stream_', '');
    handler(_objectSpread(_objectSpread({}, body), {}, {
      type: messageType
    }));
  }
}